import { Link } from 'react-router-dom';
import CookPlanner from '../components/CookPlanner';
import { HelpCircle } from 'lucide-react';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-smoke-50 via-flame-50 to-smoke-100 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-smoke-200 shadow-sm sticky top-0 z-50">
        <div className="max-w-2xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <h1 className="sr-only">BBQLabs.ai - Cook Time Calculator with Deterministic Planning and Real-Time Weather Integration</h1>
              <img 
                src="/bbqlabs-full-mark.svg" 
                alt="BBQLabs.ai - Cook Time Calculator with Deterministic Planning and Real-Time Weather Integration" 
                className="h-20 sm:h-24 md:h-28 lg:h-32 w-auto"
                title="BBQLabs.ai - Precision planning powered by thermodynamics and real-time weather data"
              />
            </div>
            <Link
              to="/how-it-works"
              className="hidden sm:flex items-center gap-2 text-sm text-flame-600 hover:text-flame-700 font-medium transition-colors"
            >
              <HelpCircle className="w-4 h-4" />
              How It Works
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow max-w-2xl mx-auto px-4 py-6 sm:py-8 sm:px-6 lg:px-8 w-full">
        <CookPlanner />
      </main>
    </div>
  );
}
